import { render, staticRenderFns } from "./AIChatbotImportButton.vue?vue&type=template&id=6ee2be56"
import script from "./AIChatbotImportButton.vue?vue&type=script&lang=js"
export * from "./AIChatbotImportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports